import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { Button, ButtonPriority } from 'wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';

import { classes, st } from './CTAGroup.st.css';
import { useModal } from '../../../../../contexts/modals/hooks';
import { DiscardChangesModal } from '../../modals';
import { DataHook } from '../../../../../constants/DataHook';
import settingsParams from '../../../settingsParams';
import { Field } from '../../../../../types';

export const CTAGroup: FC<React.PropsWithChildren<unknown>> = () => {
  const { isMobile } = useEnvironment();
  const { showModal } = useModal();
  const { resetForm } = useFormikContext<Field[]>();
  const settings = useSettings();

  return (
    <div className={st(classes.root, isMobile ? classes.mobile : undefined)}>
      <div className={classes.container}>
        <Button
          upgrade
          priority={ButtonPriority.secondary}
          onClick={() =>
            showModal(DiscardChangesModal, { onConfirm: resetForm })
          }
          data-hook={DataHook.DiscardChangesButton}
          className={classes.discardButton}
        >
          <div className={classes.buttonContent}>
            {settings.get(settingsParams.discardButtonText)}
          </div>
        </Button>

        <Button
          className={classes.saveButton}
          data-hook={DataHook.SaveAccountButton}
          type="submit"
          priority={ButtonPriority.primary}
          upgrade
        >
          <div className={classes.buttonContent}>
            {settings.get(settingsParams.saveButtonText)}
          </div>
        </Button>
      </div>
    </div>
  );
};
